import { render, staticRenderFns } from "./google-mode.vue?vue&type=template&id=4205bd1f&"
import script from "./google-mode.vue?vue&type=script&lang=js&"
export * from "./google-mode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports